<template>
  <IconLucideTriangleAlert />
</template>
